var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"block w-full p-5 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$companyTool.confFile().charte)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ccaf622","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/companies/default/views/user/settings/AccountCharte.vue
// module id = null
// module chunks = 